import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const SlotContainer = styled.div`
    display: flex;
    width: 100%;
    overflow: auto;
    flex-wrap: wrap;
    max-height: 310px;
`;

const Slot = styled.div`
    display: block;
    flex: 50%;
    box-sizing: border-box;
    flex-grow: 0;
    text-align: center;

    div{
        cursor: ${props => props.disabled ? "arrow" : "pointer"};
        font-size: 16px;
        font-weight: 400;
        white-space: nowrap;
        border-radius: 16px;
        padding: 12px 5px;
        margin: 8px 4px;
        color: ${props => props.active ? "white" : "#47566D"};
        border: 1px solid ${props => props.active ? "#47566D" : "#CCCCCC"};
        background-color: ${props => props.active ? "#47566D" : "#F2F0EE"};
        opacity: ${props => props.disabled ? "20%" : "none"};

        &:hover{
            background-color:  #7A8994;
            border:  1px solid #7A8994;
            color: white;
        }
    }
`;

class Slots extends React.Component {
    constructor(props) {
        super(props);
    }

    slots (){
        const day = this.findCurrentDay();
        const currentSlotText = this.props.currentSlot === null ? '-' : this.props.currentSlot.format('HH:mm');

        return day.slots.map((i) => {
            return {
                key: i.format('HH:mm'),
                date: i.clone(),
                active: i.format('HH:mm') === currentSlotText,
                disabled: !day.slots.find((s) => s.format('HH:mm') === i.format('HH:mm'))
            };
        });
    }

    findCurrentDay(){
        const currentDay = this.props.currentDay == null ? this.props.slots[0].date : this.props.currentDay.clone();

        return this.props.slots.find(slot => {
            return slot.date.format('YYYY-MM-DD') === currentDay.format('YYYY-MM-DD');
        });
    }

    setSlot(slot){
        if(slot.disabled){
            return;
        }

        if(this.props.currentSlot !== null && this.props.currentSlot.format('HH:mm') === slot.date.format('HH:mm')) {
            this.props.setSlot(null, null);
        } else {
            const day = this.findCurrentDay();
            const dateTime = day.date.clone().add(slot.date.format('HH:mm')).format('YYYY-MM-DD HH:mm');

            this.props.setSlot(slot.date, dateTime);
        }
    }

    render() {
        return (
            <div>
            <SlotContainer>
                {
                    this.slots().map(slot => {
                        return <Slot key={slot.key} active={slot.active} disabled={slot.disabled}>
                            <div onClick={ () => this.setSlot(slot)}>
                                {slot.date.format('hh:mm a')}
                            </div>
                        </Slot>
                    })
                }
            </SlotContainer>
            </div>
        )
    }
}

Slots.propTypes = {
    slots: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        date: PropTypes.any,
        slots:  PropTypes.arrayOf(PropTypes.any)
    })),
    currentDay: PropTypes.any,
    currentSlot: PropTypes.any,
    setSlot: PropTypes.func.isRequired
};

export default Slots;
